import { Box, styled } from "@mui/material";

export const StyledBox = styled(Box)(({ theme }) => ({
  margin: theme.spacing(10, 0),
  padding: theme.spacing(0, 14),
}));
